"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import { Vue, Component, PropSync } from "vue-property-decorator";
let VirtualShopTagStatus = class extends Vue {
};
__decorateClass([
  PropSync("column")
], VirtualShopTagStatus.prototype, "_column", 2);
VirtualShopTagStatus = __decorateClass([
  Component({
    components: {
      ItemShop
    }
  })
], VirtualShopTagStatus);
export {
  VirtualShopTagStatus as default
};
